import { createLoadActions } from '@copilot/common/store/actionCreators/list';
import { createFetchSaga } from '@copilot/common/store/saga';
import { SentModel } from '@copilot/data/responses/models/sent';
import { SENT_MESSAGES } from './constant';

export const { listWatcher: watchLoadSentMessages, loadListAction: LoadSentMessagesAction } = createFetchSaga(
	SENT_MESSAGES,
	createLoadActions<SentModel>(SENT_MESSAGES)
);
